// extracted by mini-css-extract-plugin
module.exports = {"base":"TextArea_base__ZWiRT","error":"TextArea_error__YggvH","wrapper":"TextArea_wrapper__MI2Sb","prefix":"TextArea_prefix__QpPWI","helper":"TextArea_helper__LWB5X"};